import { FunctionComponent, useState, useEffect, useMemo } from 'react';
import styles from './NavLeftLayout.module.scss';

import Box from '../../Layout/Box/Box';
import Button from '../../Input/Button/Button';
import Icon from '../../DataDisplay/Icon/Icon';
import defaultLogo from '../../DataDisplay/Icon/svgs/v-logomark.svg';
import defaultLogoSmall from '../../DataDisplay/Icon/svgs/v-logo.svg';
import { withStyles } from '../../../utils';

export type NavLeftLayoutProps = {
  navMenu: React.JSX.Element;
  logo?: string;
  smallLogo?: string;
  onLogoClick: () => void;
  onLogoutClick?: () => void;
  expandMenu?: boolean;
};

type FC = FunctionComponent<NavLeftLayoutProps>;

const cn = withStyles(styles);

const NavLeftLayout: FC = ({
  navMenu,
  logo = defaultLogo,
  smallLogo = defaultLogoSmall,
  onLogoClick,
  onLogoutClick,
  expandMenu = false,
}: NavLeftLayoutProps) => {
  const [isMobile, setIsMobile] = useState(false);
  const [logoutIsHovered, setLogoutIsHovered] = useState(false);
  const isSmall = useMemo(() => isMobile || !expandMenu, [isMobile, expandMenu]);

  window.addEventListener('resize', () => {
    window.innerWidth <= 768 ? setIsMobile(true) : setIsMobile(false);
  });

  useEffect(() => {
    window.innerWidth <= 768 ? setIsMobile(true) : setIsMobile(false);
  }, []);

  return (
    <div className={cn('navLeftLayout')}>
      <Box ac="fs" flx="col">
        <div className={cn('logoContainer')}>
          <button onClick={onLogoClick}>
            <img
              src={isSmall ? smallLogo : logo}
              alt="Logo"
              className={cn('logo', isSmall ? 'collapsed' : 'expanded')}
            />
          </button>
        </div>

        {navMenu}
      </Box>

      {onLogoutClick && (
        <div
          className={cn('logoutButtonContainer')}
          onMouseEnter={() => setLogoutIsHovered(true)}
          onMouseLeave={() => setLogoutIsHovered(false)}
        >
          <Icon icon="logOut" color={logoutIsHovered ? 'primary-light' : 'grey'} width="20px" size="md" height="20px" />

          <Button
            id="logout"
            label={isSmall ? '' : 'Log Out'}
            background={logoutIsHovered ? '#3e3e3e' : 'transparent'}
            textSize={1}
            noShadow
            textColor="white"
            onClick={onLogoutClick}
            fontWeight={500}
            height="30px"
          />
        </div>
      )}
    </div>
  );
};

export default NavLeftLayout;
